<section class="skl-lottery">
  <div class="skl-lottery__col" *ngFor="let lottery of sklLotteries">
    <ng-template #lotteryTip1
      >Je mehr Los-Anteile mit verschiedenen Los-Nummern Sie spielen, desto
      höher sind Ihre Gewinn-Chancen. Mit 4 Los-Anteilen liegt Ihre Chance auf
      einen Treffer zum Beispiel schon bei weit über 90%. Ihr Einsatz je
      Los-Anteil (bei Spielteilnahme ab Lotteriebeginn): nur 15 €<sup>3</sup>
      pro Monat.</ng-template
    >
    <ng-template #lotteryTip2
      >Je mehr Los-Anteile mit derselben Los-Nummer Sie spielen, desto höher ist
      Ihr Gewinn-Anteil bei einem Treffer. Mit 5 Los-Anteilen liegt Ihr
      Gewinn-Anteil zum Beispiel bei genau 50%. Ihr Einsatz je Los-Anteil (bei
      Spielteilnahme ab Lotteriebeginn): nur 15 €<sup>3</sup> pro
      Monat.</ng-template
    >
    <ng-template #lotteryTip3
      >Keine Lust auf halbe Sachen? Mit einem ganzen Los gehört Ihnen der Gewinn
      im Fall eines Treffers ganz allein. Sie haben also die Chance auf den
      Höchstgewinn von 20 Millionen €<sup>1</sup>. Ihr Einsatz für ein ganzes
      Los (bei Spielteilnahme ab Lotteriebeginn): 150 €<sup>3</sup> pro
      Monat.</ng-template
    >
    <!-- @TODO: Remove duplicates-->
    <i
      class="skl-lottery__info co-icon"
      *ngIf="lottery.id === '13'"
      [ngbTooltip]="lotteryTip1"
      triggers="click:blur hover"
    >
      <svg width="20" height="20" viewBox="0 0 20 20">
        <path
          d="M12.13,11.59 C11.97,12.84 10.35,14.12 9.1,14.16 C6.17,14.2 9.89,9.46 8.74,8.37 C9.3,8.16 10.62,7.83 10.62,8.81 C10.62,9.63 10.12,10.55 9.88,11.32 C8.66,15.16 12.13,11.15 12.14,11.18 C12.16,11.21 12.16,11.35 12.13,11.59 C12.08,11.95 12.16,11.35 12.13,11.59 L12.13,11.59 Z M11.56,5.67 C11.56,6.67 9.36,7.15 9.36,6.03 C9.36,5 11.56,4.54 11.56,5.67 L11.56,5.67 Z"
        ></path>
        <circle
          fill="none"
          stroke="#e0021b"
          stroke-width="1.1"
          cx="10"
          cy="10"
          r="9"
        ></circle>
      </svg>
    </i>
    <i
      class="skl-lottery__info co-icon"
      *ngIf="lottery.id === '14'"
      [ngbTooltip]="lotteryTip2"
      triggers="click:blur hover"
    >
      <svg width="20" height="20" viewBox="0 0 20 20">
        <path
          d="M12.13,11.59 C11.97,12.84 10.35,14.12 9.1,14.16 C6.17,14.2 9.89,9.46 8.74,8.37 C9.3,8.16 10.62,7.83 10.62,8.81 C10.62,9.63 10.12,10.55 9.88,11.32 C8.66,15.16 12.13,11.15 12.14,11.18 C12.16,11.21 12.16,11.35 12.13,11.59 C12.08,11.95 12.16,11.35 12.13,11.59 L12.13,11.59 Z M11.56,5.67 C11.56,6.67 9.36,7.15 9.36,6.03 C9.36,5 11.56,4.54 11.56,5.67 L11.56,5.67 Z"
        ></path>
        <circle
          fill="none"
          stroke="#e0021b"
          stroke-width="1.1"
          cx="10"
          cy="10"
          r="9"
        ></circle>
      </svg>
    </i>
    <i
      class="skl-lottery__info co-icon"
      *ngIf="lottery.id === '15'"
      [ngbTooltip]="lotteryTip3"
      triggers="click:blur hover"
    >
      <svg width="20" height="20" viewBox="0 0 20 20">
        <path
          d="M12.13,11.59 C11.97,12.84 10.35,14.12 9.1,14.16 C6.17,14.2 9.89,9.46 8.74,8.37 C9.3,8.16 10.62,7.83 10.62,8.81 C10.62,9.63 10.12,10.55 9.88,11.32 C8.66,15.16 12.13,11.15 12.14,11.18 C12.16,11.21 12.16,11.35 12.13,11.59 C12.08,11.95 12.16,11.35 12.13,11.59 L12.13,11.59 Z M11.56,5.67 C11.56,6.67 9.36,7.15 9.36,6.03 C9.36,5 11.56,4.54 11.56,5.67 L11.56,5.67 Z"
        ></path>
        <circle
          fill="none"
          stroke="#e0021b"
          stroke-width="1.1"
          cx="10"
          cy="10"
          r="9"
        ></circle>
      </svg>
    </i>
    <h4
      class="skl-lottery__title"
      *ngIf="lottery.id === '13' || lottery.id === '14'"
    >
      Los-Anteile
    </h4>
    <h4 class="skl-lottery__title" *ngIf="lottery.id === '15'">
      {{ lottery.name }}
    </h4>
    <p *ngIf="lottery.id === '13'">verschiedener Los-Nummern</p>
    <p *ngIf="lottery.id === '14'">gleicher Los-Nummern</p>
    <p *ngIf="lottery.id === '15'">&nbsp;</p>

    <img
      src="https://cdn.gloeckle.de/orbit-skl/resources/assets/images/losanteile-versch.png"
      *ngIf="lottery.id === '13'"
      alt="Verschiedene Lose Icon"
      class="skl-lottery__image"
    />
    <img
      src="https://cdn.gloeckle.de/orbit-skl/resources/assets/images/losanteile-gleich.png"
      *ngIf="lottery.id === '14'"
      alt="Gleiche Lose Icon"
      class="skl-lottery__image"
    />
    <img
      src="https://cdn.gloeckle.de/orbit-skl/resources/assets/images/losanteile-ganz.png"
      *ngIf="lottery.id === '15'"
      alt="Ganzes Los Icon"
      class="skl-lottery__image"
    />
    <p class="skl-lottery__text">
      <strong>{{
        lottery.price | currency : 'EUR' : 'symbol' : '1.2-2'
      }}</strong
      ><sup>3</sup> pro Los-Anteil und Klasse
    </p>
    <h4 class="skl-lottery__count-title">
      Anzahl der <span *ngIf="lottery.id !== '15'">Los-Anteile</span
      ><span *ngIf="lottery.id === '15'">Lose</span>:
    </h4>
    <app-ticket-conf
      [product]="lottery"
      [odds]="lotteries.odds"
    ></app-ticket-conf>
  </div>
</section>

<section
  class="skl-joker"
  *ngFor="let lottery of jokerLotteries"
  [ngClass]="{
    'skl-joker--eurojoker': lottery.id === '16',
    'skl-joker--dreamjoker': lottery.id === '17' && jokerType !== 'Weihnachts',
    'skl-joker--christmasjoker':
      lottery.id === '17' && jokerType === 'Weihnachts'
  }"
>
  <ng-template #jokerTip1>
    Ihre Chancen beim SKL EURO-JOKER: stündliche Geldgewinne, tägliche
    Sofort-Renten und jeden Monat 1 x 500.000 € in bar. Ihr Einsatz je
    EURO-JOKER-Los: nur 10 €<sup>3</sup> pro Monat.</ng-template
  >
  <ng-template #jokerTip2>
    Ihre Chancen beim SKL
    <span *ngIf="jokerType === 'Weihnachts'">WEIHNACHTS-JOKER</span
    ><span *ngIf="jokerType !== 'Weihnachts'">TRAUM-JOKER</span>: 836.112
    Gewinne pro Woche - monatlicher Höchstgewinn: 500.000 € in bar<sup>2</sup>.
    Ihr Einsatz je SKL TRAUM-JOKER-Los: nur 5 €<sup>3</sup>
    pro Monat.
  </ng-template>
  <i
    class="skl-joker__info co-icon"
    *ngIf="lottery.id === '16'"
    [ngbTooltip]="jokerTip1"
    triggers="click:blur hover"
  >
    <svg width="20" height="20" viewBox="0 0 20 20">
      <path
        d="M12.13,11.59 C11.97,12.84 10.35,14.12 9.1,14.16 C6.17,14.2 9.89,9.46 8.74,8.37 C9.3,8.16 10.62,7.83 10.62,8.81 C10.62,9.63 10.12,10.55 9.88,11.32 C8.66,15.16 12.13,11.15 12.14,11.18 C12.16,11.21 12.16,11.35 12.13,11.59 C12.08,11.95 12.16,11.35 12.13,11.59 L12.13,11.59 Z M11.56,5.67 C11.56,6.67 9.36,7.15 9.36,6.03 C9.36,5 11.56,4.54 11.56,5.67 L11.56,5.67 Z"
      ></path>
      <circle
        fill="none"
        stroke-width="1.1"
        stroke="#e0021b"
        cx="10"
        cy="10"
        r="9"
      ></circle>
    </svg>
  </i>
  <i
    class="skl-joker__info co-icon"
    *ngIf="lottery.id === '17'"
    [ngbTooltip]="jokerTip2"
    triggers="click:blur hover"
  >
    <svg width="20" height="20" viewBox="0 0 20 20">
      <path
        d="M12.13,11.59 C11.97,12.84 10.35,14.12 9.1,14.16 C6.17,14.2 9.89,9.46 8.74,8.37 C9.3,8.16 10.62,7.83 10.62,8.81 C10.62,9.63 10.12,10.55 9.88,11.32 C8.66,15.16 12.13,11.15 12.14,11.18 C12.16,11.21 12.16,11.35 12.13,11.59 C12.08,11.95 12.16,11.35 12.13,11.59 L12.13,11.59 Z M11.56,5.67 C11.56,6.67 9.36,7.15 9.36,6.03 C9.36,5 11.56,4.54 11.56,5.67 L11.56,5.67 Z"
      ></path>
      <circle
        fill="none"
        stroke-width="1.1"
        stroke="#e0021b"
        cx="10"
        cy="10"
        r="9"
      ></circle>
    </svg>
  </i>
  <div class="skl-joker__row">
    <div class="skl-joker__col" *ngIf="lottery.id === '16'">
      <h4>Stündliche Geldgewinne und tägliche Sofort-Renten</h4>
      <ul class="hidden-sm hidden-xs product-info">
        <li>stündlich Sofort-Geld-Gewinne: 10.000 € - 24 x am Tag</li>
        <li>täglich mind. 1 große 10 Jahres-Sofort-Rente</li>
        <li>monatlich 1 x 500.000 € in bar</li>
      </ul>
    </div>
    <div class="skl-joker__col" *ngIf="lottery.id === '17'">
      <h4>Traumhafte Geld- und Sachgewinne</h4>
      <ul class="hidden-sm hidden-xs product-info">
        <li>jede Woche 836.112 Gewinne</li>
        <li>Traumautos, Tiny Houses, Gold und Geld</li>
        <li>Jeden Monat 1 x 500.000 €<sup>2</sup> in bar</li>
      </ul>
    </div>
    <div class="skl-joker__col">
      <h4 class="skl-joker__title" *ngIf="lottery.id === '16'">
        Anzahl EURO-JOKER Lose:
      </h4>
      <h4 class="skl-joker__title" *ngIf="lottery.id === '17'">
        Anzahl
        <span *ngIf="jokerType === 'Weihnachts'">WEIHNACHTS-JOKER</span
        ><span *ngIf="jokerType !== 'Weihnachts'">TRAUM-JOKER</span>
        Lose:
      </h4>
      <app-ticket-conf
        [product]="lottery"
        [odds]="lotteries.odds"
        *ngIf="lotteries"
      ></app-ticket-conf>
    </div>
  </div>
</section>
